import { HeaderButtons } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/HeaderButtons';
import type { ReportActionState } from '@/features/invoice_reports/types';
import { useTranslation } from '@/i18n';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

type TitleInfo = {
  title: string;
  number: string;
};

type DrawerTitleProps = {
  titleInfo: TitleInfo;
  reportId: string;
  detailPath?: string;
  editPath?: string;
  editAction?: ReportActionState;
  deleteAction?: ReportActionState;
  cancelAction?: ReportActionState;
  isCopyable?: boolean;
  reportTotalAmount?: string | null;
  apPayeeName?: string | null;
};

export const DrawerTitle: FC<DrawerTitleProps> = memo(
  ({
    titleInfo,
    reportId,
    detailPath,
    editPath,
    editAction,
    deleteAction,
    cancelAction,
    isCopyable,
    reportTotalAmount,
    apPayeeName,
  }) => {
    const { t } = useTranslation();

    return (
      <div className={cx('container')}>
        <div className={cx('header-leading-container')}>
          <div className={cx('info-container')}>
            <div className={cx('payment-request-number')}>
              <span className={cx('label')}>
                {t('approving_invoice_report_detail_number')}：
              </span>
              <span className={cx('value')}>{titleInfo.number}</span>
            </div>
            <div className={cx('payment-request-title')}>
              <span className={cx('label')}>
                {t('approving_invoice_report_detail_title')}：
              </span>
              <span className={cx('value')}>{titleInfo.title}</span>
            </div>
          </div>
        </div>
        <HeaderButtons
          reportId={reportId}
          detailPath={detailPath}
          editPath={editPath}
          editAction={editAction}
          deleteAction={deleteAction}
          cancelAction={cancelAction}
          isCopyable={isCopyable}
          reportNumber={titleInfo.number}
          reportTitle={titleInfo.title}
          reportTotalAmount={reportTotalAmount}
          apPayeeName={apPayeeName}
        />
      </div>
    );
  }
);

DrawerTitle.displayName = 'DrawerTitle';
